<div class="order-detail__header">Loja - Detalhes da recorrência</div>
<div class="order-detail__content" *ngIf="recurrence">
  <div class="order-detail__content__left">
    <app-person-card
      *ngIf="person"
      [showProfileLink]="recurrence.shop !== 'mensmarket'"
      [background]="recurrence.shop === 'mensmarket' && 'blue'"
      [showResetPassword]="recurrence.shop !== 'mensmarket'"
      [person]="person"
      [showProfileLink]="person?.personId > 0"
      [showResetPassword]="person?.personId > 0"
      [subscriptionId]="recurrence.shop === 'mensmarket' ? 3 : 1"
    />
  </div>
  <div class="order-detail__content__right">
    <div class="card shipping-order">
      <span class="info">
        <strong>Loja:</strong>&nbsp;
        <span>{{ shopName }}</span>
      </span>
      <span class="info">
        <strong>ID</strong>:
        <span>{{ recurrence.id }}</span>
      </span>
      <span class="info">
        <strong>Criada em</strong>:
        {{ recurrence.createdAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info info--with-badge">
        <strong>Status</strong>:
        <span
          class="status"
          [class.status--active]="
            recurrence.status === 'active'
          "
          [class.status--warning]="
            recurrence.status === 'paused' ||
            recurrence.status === 'waiting_stock'
          "
          [class.status--danger]="
            recurrence.status === 'cancelled' ||
            recurrence.status === 'payment_failed'
          "
        >
          {{ statusLabel }}
        </span>
        <span class="status-raw">({{ recurrence.status }})</span>
      </span>
      <span class="info info--with-badge">
        <strong>Ativo</strong>:
        <span
          class="status"
          [class.status--active]="recurrence.active"
          [class.status--danger]="!recurrence.active"
        >
          {{ activeLabel }}
        </span>
      </span>
      <span class="info">
        <strong>Ciclo</strong>:
        {{ cycleLabel }}
      </span>
      <div class="cycle-editor" *ngIf="canEditFrequency">
        <p-dropdown
          [formControl]="cycleControl"
          [options]="cycleOptions"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o novo ciclo"
          appendTo="body"
        />
        <p-button
          label="Alterar ciclo"
          severity="secondary"
          size="small"
          [disabled]="
            !cycleControl.value ||
            cycleControl.value === recurrence.recurrenceCycle
          "
          (onClick)="askUpdateFrequency()"
        />
      </div>
      <span class="info">
        <strong>Próxima cobrança</strong>:
        {{ recurrence.nextChargeDate | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info" *ngIf="recurrence.updatedAt">
        <strong>Atualizada em</strong>:
        {{ recurrence.updatedAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info" *ngIf="recurrence.cancelledAt">
        <strong>Cancelada em</strong>:
        {{ recurrence.cancelledAt | date: 'dd/MM/yyyy HH:mm' }}
      </span>
      <span class="info">
        <strong>Cupom</strong>:
        {{ recurrence.coupon?.nickname || 'Sem cupom' }}
      </span>
      <span class="info" *ngIf="recurrence.discount">
        <strong>Desconto</strong>:
        {{ recurrence.discount | currency: 'BRL' }}
      </span>
      <span class="info" *ngIf="recurrence.originalOrderId">
        <strong>Pedido original</strong>:&nbsp;
        <a
          [routerLink]="'/shop-orders/order/' + recurrence.originalOrderId"
          class="data-link"
          [class.data-link--mens]="recurrence.shop === 'mensmarket'"
          target="_blank"
        >
          {{ recurrence.originalOrderId }}
        </a>
      </span>
      <span class="info" *ngIf="recurrence.lastOrderId">
        <strong>Último pedido</strong>:&nbsp;
        <a
          [routerLink]="'/shop-orders/order/' + recurrence.lastOrderId"
          class="data-link"
          [class.data-link--mens]="recurrence.shop === 'mensmarket'"
          target="_blank"
        >
          {{ recurrence.lastOrderId }}
        </a>
      </span>
      <div class="shipping-summary">
        <span class="info">
          <strong>Frete</strong>:&nbsp;
          <ng-container *ngIf="recurrence.shippingPrice">
            {{ recurrence.shippingPrice | currency: 'BRL' }}
          </ng-container>
          <ng-container *ngIf="!recurrence.shippingPrice"> Grátis </ng-container>
        </span>
        <span
          class="info"
          *ngIf="
            recurrence.shipping?.description ||
            recurrence.shipping?.DaysToDelivery
          "
        >
          <strong>Prazo de entrega</strong>:
          {{
            recurrence.shipping?.description ||
              recurrence.shipping?.DaysToDelivery + ' dia(s)'
          }}
        </span>
        <span class="info">
          <strong>Transportadora</strong>:
          {{ recurrence.shipping?.ShippingCompanyName || 'Não informado' }}
        </span>
        <span
          class="info info--full"
          *ngIf="
            recurrence.shippingAddress?.street &&
            recurrence.shippingAddress?.city &&
            recurrence.shippingAddress?.state
          "
        >
          <strong>Endereço</strong>:
          {{ recurrence.shippingAddress.street }}
          {{ recurrence.shippingAddress.number
          }}<span *ngIf="recurrence.shippingAddress.extension?.length"
            >, {{ recurrence.shippingAddress.extension }}</span
          >
          - {{ recurrence.shippingAddress.district }},
          {{ recurrence.shippingAddress.city }} -
          {{ recurrence.shippingAddress.state }}, Brasil, CEP
          {{ recurrence.shippingAddress.zip }}
        </span>
        <span
          class="info info--full"
          *ngIf="recurrence.shipping?.additionalDescription"
        >
          <strong>Detalhes</strong>:
          {{ recurrence.shipping.additionalDescription }}
        </span>
      </div>
      <div class="payment-summary">
        <span>
          <p>
            <strong>
              <i
                class="pi"
                [class.pi-barcode]="recurrence.paymentMethod === 'boleto'"
                [class.pi-qrcode]="recurrence.paymentMethod === 'pix'"
                [class.pi-credit-card]="
                  recurrence.paymentMethod === 'credit_card'
                "
              ></i>
              {{ methodName | titlecase }}
            </strong>
          </p>
          <p *ngFor="let card of recurrence.cards">
            <strong>{{ card.paymentProvider | titlecase }}</strong>:
            {{ card.cardId }}
          </p>
          <p>
            <strong>Valor</strong>:
            {{ recurrence.totalPrice | currency: 'BRL' }}
          </p>
        </span>
        <span class="payment-summary__summary">
          <h3>Resumo</h3>
          <p *ngIf="recurrence.shop !== 'Glampoints'">
            <strong>Subtotal:</strong>
            <span>{{ recurrence.subTotalPrice | currency: 'BRL' }}</span>
          </p>
          <p *ngIf="recurrence.shippingPrice">
            <strong>Entrega:</strong>
            <span>{{ recurrence.shippingPrice | currency: 'BRL' }}</span>
          </p>
          <p *ngIf="!recurrence.shippingPrice">
            <strong>Entrega:</strong><span>Grátis</span>
          </p>
          <p *ngIf="recurrence.discount && recurrence.shop !== 'Glampoints'">
            <strong>Cupom (-):</strong>
            <span class="payment-summary__discount">
              {{ recurrence.discount | currency: 'BRL' }}
            </span>
          </p>
          <p>
            <strong>Total:</strong>
            <span>{{ recurrence.totalPrice | currency: 'BRL' }}</span>
          </p>
        </span>
      </div>
      <span class="buttons" *ngIf="canToggleActive">
        <p-button
          *ngIf="canToggleActive"
          [label]="recurrence.active ? 'Desativar' : 'Ativar'"
          [severity]="recurrence.active ? 'warning' : 'success'"
          (onClick)="askToggleActive()"
        />
      </span>
    </div>
    <div class="card">
      <p-tabView
        [activeIndex]="selectedTab"
        (activeIndexChange)="tabChanged($event)"
      >
        <p-tabPanel header="Produtos">
          <div class="order-detail__tab">
            <app-table
              [cols]="productCols"
              *ngIf="recurrence && tableReady"
              modelName="produtos"
              tableTitle="Itens da recorrência"
              [elements]="recurrence.lineItems"
              [lazy]="false"
              [addButton]="false"
              [paginator]="false"
            />
          </div>
        </p-tabPanel>
        <p-tabPanel header="Endereços">
          <div class="order-detail__tab">
            <p-fieldset legend="Entrega">
              <div class="tab-summary">
                <div class="group">
                  <div class="field">
                    <p>
                      <strong>Destinatário:</strong>
                      {{
                        recurrence.shippingAddress?.recipient ||
                          'Não informado'
                      }}
                    </p>
                    <p>
                      <strong>CEP:</strong>
                      {{ recurrence.shippingAddress?.zip || 'Não informado' }}
                    </p>
                    <p>
                      <strong>Endereço:</strong>
                      {{ recurrence.shippingAddress?.street || '—' }},
                      {{ recurrence.shippingAddress?.number || '—' }}
                    </p>
                    <p *ngIf="recurrence.shippingAddress?.extension">
                      <strong>Complemento:</strong>
                      {{ recurrence.shippingAddress.extension }}
                    </p>
                  </div>
                  <div class="field">
                    <p>
                      <strong>Bairro:</strong>
                      {{
                        recurrence.shippingAddress?.district || 'Não informado'
                      }}
                    </p>
                    <p>
                      <strong>Cidade/UF:</strong>
                      {{ recurrence.shippingAddress?.city || '—' }} -
                      {{ recurrence.shippingAddress?.state || '—' }}
                    </p>
                  </div>
                </div>
              </div>
            </p-fieldset>
            <p-fieldset legend="Cobrança">
              <div class="tab-summary">
                <ng-container *ngIf="recurrence.billingAddress; else sameAddress">
                  <div class="group">
                    <div class="field">
                      <p>
                        <strong>Destinatário:</strong>
                        {{
                          recurrence.billingAddress?.recipient ||
                            'Não informado'
                        }}
                      </p>
                      <p>
                        <strong>CEP:</strong>
                        {{ recurrence.billingAddress?.zip || 'Não informado' }}
                      </p>
                      <p>
                        <strong>Endereço:</strong>
                        {{ recurrence.billingAddress?.street || '—' }},
                        {{ recurrence.billingAddress?.number || '—' }}
                      </p>
                    </div>
                    <div class="field">
                      <p>
                        <strong>Bairro:</strong>
                        {{
                          recurrence.billingAddress?.district ||
                            'Não informado'
                        }}
                      </p>
                      <p>
                        <strong>Cidade/UF:</strong>
                        {{ recurrence.billingAddress?.city || '—' }} -
                        {{ recurrence.billingAddress?.state || '—' }}
                      </p>
                    </div>
                  </div>
                </ng-container>
                <ng-template #sameAddress>
                  <p>Mesmo endereço de entrega</p>
                </ng-template>
              </div>
            </p-fieldset>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Edições">
          <div class="order-detail__tab">
            <app-table
              [cols]="editionCols"
              *ngIf="recurrence && tableReady"
              modelName="edições"
              tableTitle="Edições da recorrência"
              [elements]="editions"
              [lazy]="false"
              [addButton]="false"
              [defaultRows]="25"
              [actionButtons]="editionActionButtons"
            />
          </div>
        </p-tabPanel>
        <p-tabPanel header="Histórico" *ngIf="recurrence.history?.length">
          <div class="order-detail__tab">
            <app-table
              [cols]="historyCols"
              *ngIf="recurrence && tableReady"
              modelName="histórico"
              tableTitle="Histórico da recorrência"
              [elements]="recurrence.history"
              [lazy]="false"
              [addButton]="false"
              [defaultRows]="25"
            />
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>

<p-toast />
<p-confirmDialog />
